export class Drug {
    id = null;
    name = null;
    drugGroup = null;
    code = null;
    description = null;
    isDuplicate = null;
    dupName = null;
    dupCode = null;
    route = null;
    frequency = null;
}